import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";

export default function Seller() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/sellers/${id}`).then((r) => setS(r.data)).catch(() => setErr(true)); }, [id]);
  if (err) return <div className="py-32 text-center text-slate-500" data-testid="seller-not-found">البائع غير موجود.</div>;
  if (!s) return <div className="py-32 text-center text-slate-400">جارِ التحميل...</div>;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="seller-page">
      <div className="bg-white border border-slate-200 rounded-xl p-6 mb-8 flex flex-wrap items-center justify-between gap-4 shadow-sm">
        <div>
          <div className="text-xs font-medium text-slate-500 mb-1">صفحة البائع</div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 flex items-center gap-2" data-testid="seller-name">
            {s.name}
            {s.verified && <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-2 py-1" data-testid="seller-verified-badge"><BadgeCheck size={14} />موثّق بالسجل التجاري</span>}
          </h1>
          {s.member_since && <div className="text-sm text-slate-500 mt-2 flex items-center gap-1.5"><CalendarDays size={14} />عضو منذ {new Date(s.member_since).toLocaleDateString("ar-SA-u-nu-latn", { year: "numeric", month: "long" })}</div>}
        </div>
        <div className="text-center px-6 border-r border-slate-200">
          <div className="text-2xl font-bold font-mono tabular-nums" data-testid="seller-listings-count">{s.listings.length}</div>
          <div className="text-xs text-slate-500">إعلان منشور</div>
        </div>
      </div>
      {s.listings.length === 0 ? <div className="text-center py-16 text-slate-500 bg-white border border-slate-200 rounded-xl">لا توجد إعلانات منشورة لهذا البائع.</div>
        : <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="seller-listings">{s.listings.map((l) => <ListingCard key={l.id} l={l} />)}</div>}
    </div>
  );
}
